export const splitMetadataRule = (rule: string | undefined) => {
  const safeRule = rule || '';
  const delimiter = ' - ';
  const delimiterIndex = safeRule.indexOf(delimiter);

  if (delimiterIndex === -1) {
    return {
      ruleName: safeRule,
      ruleValue: '',
    };
  }

  return {
    ruleName: safeRule.slice(0, delimiterIndex),
    ruleValue: safeRule.slice(delimiterIndex + delimiter.length),
  };
};

export const getFurtherVerificationDisplay = (
  status: string | undefined,
  ruleValue: string | undefined
) => {
  const normalizedRuleValue = (ruleValue || '').trim();

  if (status?.toUpperCase() === 'PASS' && !normalizedRuleValue) {
    return 'No discrepancies found';
  }

  return normalizedRuleValue;
};

export const getMetadataDisplayStatus = (
  status: string | undefined,
  docStateType: string | undefined,
  ruleName: string | undefined,
  ruleValue: string | undefined,
  noRuleParadigmActive = false
) => {
  const normalizedStatus = (status || '').trim().toUpperCase();
  if (noRuleParadigmActive && normalizedStatus !== 'PASS' && [
    'FAIL',
    'NEED VERIFICATION',
    'NEEDS VERIFICATION',
  ].includes(normalizedStatus)) {
    return 'NA';
  }

  if (normalizedStatus !== 'NEED VERIFICATION' && normalizedStatus !== 'NEEDS VERIFICATION') {
    return status;
  }

  const normalizedDocStateType = (docStateType || '').trim().toLowerCase();
  const usesNoTemplateRules = normalizedDocStateType === 'unknown' || normalizedDocStateType === 'no';
  const normalizedRuleName = (ruleName || '').trim().toLowerCase();
  const normalizedRuleValue = (ruleValue || '').trim().toLowerCase();
  const isUnknownTemplateResult = normalizedRuleName === 'further verification'
    && (normalizedRuleValue.includes('unknown template')
      || normalizedRuleValue.includes('no matching template'));

  return usesNoTemplateRules || isUnknownTemplateResult ? 'NA' : status;
};

type MetadataRule = {
  rule?: string;
  status?: string;
};

export const isNoRuleMetadataParadigm = (
  metadataChecks: MetadataRule[] | undefined,
  docStateType: string | undefined
) => {
  const normalizedDocStateType = (docStateType || '').trim().toLowerCase();
  const usesNoTemplateRules = normalizedDocStateType === 'unknown' || normalizedDocStateType === 'no';

  return (metadataChecks || []).some((item) => {
    const normalizedStatus = (item.status || '').trim().toUpperCase();
    if (normalizedStatus !== 'NEED VERIFICATION' && normalizedStatus !== 'NEEDS VERIFICATION') {
      return false;
    }

    const { ruleName, ruleValue } = splitMetadataRule(item.rule);
    if (ruleName.trim().toLowerCase() !== 'further verification') {
      return false;
    }

    const normalizedRuleValue = ruleValue.trim().toLowerCase();
    return usesNoTemplateRules
      || normalizedRuleValue.includes('unknown template')
      || normalizedRuleValue.includes('no matching template');
  });
};
